// KL wspolne dla wszystkich szablonow (wydzielone z kl-home.js 08.10.2026, perf fix):
// ikony w mega menu (Pomieszczenia, Styl) + dostepnosc mega menu z klawiatury.
// mega menu (07.10.2026): podzakladki Pomieszczenia i Styl jako ikony w kwadratach
const KL_MENU_IKONY = {
  'pomieszczenie-biuro': '<rect x="3" y="4" width="18" height="11" rx="1.5"/><path d="M8 20h8M12 15v5"/>',
  'pomieszczenie-elewacja-taras': '<path d="M3 11 12 4l9 7"/><path d="M5 10v10h14V10"/><path d="M10 20v-5h4v5"/>',
  'pomieszczenie-jadalnia': '<path d="M3 10h18M6 10v9M18 10v9"/><path d="M9 6c0-1.5 1.3-3 3-3s3 1.5 3 3"/><path d="M12 3v3"/>',
  'pomieszczenie-korytarz': '<path d="M6 21V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v17"/><path d="M3 21h18"/><circle cx="14.5" cy="12" r=".8" fill="currentColor"/>',
  'pomieszczenie-kuchnia': '<path d="M4 10h16v7a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3z"/><path d="M2 10h2M20 10h2"/><path d="M9 6c0-1 1-1.5 1-2.5M14 6c0-1 1-1.5 1-2.5"/>',
  'pomieszczenie-ogrod': '<path d="M12 21v-7"/><path d="M12 14c-4 0-6-3-6-6a6 6 0 0 1 12 0c0 3-2 6-6 6z"/><path d="M8 21h8"/>',
  'pomieszczenie-pokoj-dzieciecy': '<path d="M12 3c3 0 5 2.5 5 5.5S14.5 15 12 15 7 11.5 7 8.5 9 3 12 3z"/><path d="M12 15v3m-1 3 1-3 1 3"/>',
  'pomieszczenie-salon': '<path d="M4 11V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3"/><path d="M2 13a2 2 0 0 1 4 0v2h12v-2a2 2 0 0 1 4 0v4H2z"/><path d="M5 17v2M19 17v2"/>',
  'pomieszczenie-schody': '<path d="M3 20h5v-5h5v-5h5V5h3"/>',
  'pomieszczenie-sypialnia': '<path d="M3 18V7M21 18v-5a3 3 0 0 0-3-3h-8v6"/><path d="M3 15h18"/><circle cx="6.5" cy="11.5" r="1.5"/>',
  'pomieszczenie-lazienka': '<path d="M3 12h18v2a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5z"/><path d="M6 12V6a2 2 0 0 1 4 0"/><path d="M7 19l-1 2M17 19l1 2"/>',
  'styl-glamour': '<path d="M6 4h12l3 5-9 11L3 9z"/><path d="M3 9h18M9 4l3 16M15 4l-3 16"/>',
  'styl-industrialny': '<path d="M12 2v5"/><path d="M6 13a6 6 0 0 1 12 0z"/><path d="M9 17a3 3 0 0 0 6 0"/>',
  'styl-japandi': '<circle cx="12" cy="9" r="5"/><path d="M5 20c2-2 4.5-3 7-3s5 1 7 3"/>',
  'styl-klasyczny': '<path d="M12 3v3M7 8h10l-2 4H9z"/><path d="M5 12h14M8 12v3a4 4 0 0 0 8 0v-3"/><path d="M12 19v2"/>',
  'styl-modern-classic': '<path d="M7 4h10l-2 7H9z"/><path d="M12 11v8M8 20h8"/>',
  'styl-new-york': '<path d="M3 21V10h4V5h4v6h3V3h4v8h3v10"/><path d="M2 21h20"/>',
  'styl-nowoczesny': '<path d="M4 20 20 4"/><circle cx="17" cy="7" r="3"/><path d="M4 20h7"/>',
  'styl-prowansalski': '<path d="M12 21v-6"/><path d="M12 15c-2-1-3-3-3-5M12 15c2-1 3-3 3-5M12 12c-1.5-2-1.5-5 0-8 1.5 3 1.5 6 0 8z"/>',
  'styl-skandynawski': '<path d="M12 3 5 13h4l-3 5h12l-3-5h4z"/><path d="M12 18v3"/>'
};
function menuIkony() {
  document.querySelectorAll('.mega-menu__list').forEach((ul) => {
    if (ul.querySelector('.klm-ik')) return;
    const linki = [...ul.querySelectorAll('a.mega-menu__link')];
    const zIkona = linki.filter((a) => KL_MENU_IKONY[(a.getAttribute('href') || '').split('?')[0].split('/').pop()]);
    if (!zIkona.length || zIkona.length < linki.length / 2) return;
    ul.dataset.klmIkony = '1';
    ul.classList.add('klm-ikony');
    zIkona.forEach((a) => {
      const k = a.getAttribute('href').split('?')[0].split('/').pop();
      a.insertAdjacentHTML('afterbegin', `<span class="klm-ik" aria-hidden="true"><svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">${KL_MENU_IKONY[k]}</svg></span>`);
    });
  });
}
menuIkony();
document.addEventListener('DOMContentLoaded', menuIkony);
setTimeout(menuIkony, 1500);
// naglowek jest przerenderowywany przez motyw (morph) - ikony dokladamy ponownie przy najechaniu na menu
document.addEventListener('pointerover', (e) => { if (e.target.closest && e.target.closest('.menu-list__list-item, .menu-drawer')) menuIkony(); }, { passive: true });
document.addEventListener('focusin', (e) => { if (e.target.closest && e.target.closest('.menu-list__list-item')) menuIkony(); });

// mega menu z klawiatury (08.10.2026):
// - Escape zamyka otwarty panel i wraca fokusem do pozycji glownego menu,
// - linki w ZAMKNIETYM panelu maja tabindex=-1 (Tab nie wchodzi w ~30 ukrytych linkow); po otwarciu panelu
//   (najechanie, fokus na pozycji menu) wracaja do kolejnosci tabulacji - zachowanie przy otwartym panelu bez zmian.
const KL_FOKUS = 'a[href], button, input, select, textarea, [tabindex]';
function klMenuTab() {
  document.querySelectorAll('a.menu-list__link[aria-controls]').forEach((a) => {
    const panel = document.getElementById(a.getAttribute('aria-controls'));
    if (!panel) return;
    const otwarty = a.getAttribute('aria-expanded') === 'true';
    panel.querySelectorAll(KL_FOKUS).forEach((el) => {
      if (otwarty) {
        if (el.dataset.klTab === '1') { el.removeAttribute('tabindex'); delete el.dataset.klTab; }
      } else if (!el.hasAttribute('tabindex')) {
        el.setAttribute('tabindex', '-1'); el.dataset.klTab = '1';
      }
    });
  });
}
function klMenuStart() {
  const hg = document.getElementById('header-group');
  if (!hg || hg.dataset.klMenuTab) return;
  hg.dataset.klMenuTab = '1';
  klMenuTab();
  new MutationObserver(klMenuTab).observe(hg, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-expanded'] });
}
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape' || !e.target.closest) return;
  const li = e.target.closest('.menu-list__list-item');
  const link = li && li.querySelector('a.menu-list__link[aria-expanded="true"]');
  if (!link) return;
  const menu = li.closest('header-menu');
  link.focus();
  if (menu && typeof menu.deactivate === 'function') menu.deactivate({ target: li });
  e.preventDefault();
});
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', klMenuStart); else klMenuStart();

// Rabaty automatyczne Google (Simprosys SPD, 13.10.2026): aplikacja naklada kod GSF-SPD-* przez GET /discount/<kod>
// ok. 2 s po wczytaniu karty produktu. Gdy klient doda produkt wczesniej, koszyk boczny zostaje z cena bez rabatu
// (klientka: "widze 379,23 zl, a do koszyka dodaje sie 414,17 zl"), choc koszyk i kasa licza juz rabat.
// Po kazdym nalozeniu/zdjeciu kodu przez /discount/ przerysowujemy koszyk (to samo zdarzenie co pole kodu rabatowego).
(function () {
  if (window.klSpdKoszyk) return;
  window.klSpdKoszyk = true;
  let czekaj;
  const odswiez = () => {
    clearTimeout(czekaj);
    czekaj = setTimeout(() => {
      import('@theme/events')
        .then((m) => document.dispatchEvent(new m.DiscountUpdateEvent({}, 'kl-spd')))
        .catch(() => {});
    }, 300);
  };
  const open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (metoda, url) {
    if (typeof url === 'string' && /\/discount\/[^/?#]+/.test(url)) this.addEventListener('loadend', odswiez);
    return open.apply(this, arguments);
  };
})();

// Koszyk boczny "Dokup zrodlo swiatla" (snippets/kl-zarowki, 13.10.2026): pole ilosci przy kazdej zarowce.
// Przycisk motywu (quick-add) wysyla ukryte pole quantity=1 - w fazie capture, przed handleSubmit motywu,
// wpisujemy tam wartosc z pola. Odmowe Shopify (np. za malo na stanie) motyw zglasza zdarzeniem cart:error -
// pokazujemy ja pod lista, bo przycisk w koszyku nie ma miejsca na komunikat.
(function () {
  if (window.klZarIlosc) return;
  window.klZarIlosc = true;
  const maks = (li) => {
    const m = parseInt(li && li.querySelector('[data-kl-zar-max]')?.dataset.klZarMax, 10);
    return m > 0 ? m : 99;
  };
  const pole = (li) => (li ? li.querySelector('[data-kl-zar-ilosc]') : null);
  const ilosc = (li) => {
    const n = parseInt(pole(li)?.value, 10);
    return Math.min(n >= 1 ? n : 1, maks(li));
  };
  const odswiez = (li) => {
    const n = ilosc(li);
    const p = pole(li);
    if (p && String(p.value) !== String(n)) p.value = n;
    li.querySelectorAll('[data-kl-zar-krok]').forEach((b) => {
      b.disabled = Number(b.dataset.klZarKrok) < 0 ? n <= 1 : n >= maks(li);
    });
  };
  const blad = (el, txt) => {
    const b = el?.closest('.kl-zar')?.querySelector('[data-kl-zar-blad]');
    if (!b) return;
    b.textContent = txt || '';
    b.hidden = !txt;
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest ? e.target.closest('[data-kl-zar-krok]') : null;
    if (!b) return;
    e.preventDefault();
    const li = b.closest('.kl-zar__poz');
    const p = pole(li);
    if (!p) return;
    p.value = Math.max(1, Math.min(maks(li), ilosc(li) + Number(b.dataset.klZarKrok)));
    odswiez(li);
    blad(li, '');
  });
  document.addEventListener('change', (e) => {
    if (e.target.matches && e.target.matches('[data-kl-zar-ilosc]')) odswiez(e.target.closest('.kl-zar__poz'));
  });
  // window capture: przed delegacja motywu (component.js lapie submit na document w fazie capture i czyta FormData)
  window.addEventListener('submit', (e) => {
    const form = e.target;
    const li = form && form.closest ? form.closest('.kl-zar__poz') : null;
    if (!li || !pole(li)) return;
    const q = form.querySelector('input[name="quantity"]');
    if (q) q.value = ilosc(li);
    blad(li, '');
  }, true);
  document.addEventListener('cart:error', (e) => {
    const t = e.target;
    if (!t || !t.closest || !t.closest('.kl-zar')) return;
    const d = e.detail?.data || {};
    blad(t, (typeof d.description === 'string' && d.description) || d.message || 'Nie udało się dodać do koszyka.');
  });
})();

/* KL runda 10 (03.11.2026): znaczek -X% na kartach produktow po zmianie wariantu na karcie.
   Procent liczy Liquid (snippets/product-card-badges.liquid); tu tylko aktualizacja, gdy klient wybierze inny wariant
   (zdarzenie variant:update niesie wariant z cena i cena przekreslona w groszach). window+capture: karta zatrzymuje
   zdarzenie u siebie, a nasz kod ma tylko poczekac na jej przerysowanie (rAF). */
(() => {
  if (window.klPct) return;
  window.klPct = true;
  window.addEventListener('variant:update', (e) => {
    const card = e.target && e.target.closest ? e.target.closest('product-card') : null;
    const v = e.detail && e.detail.resource;
    if (!card || !v) return;
    requestAnimationFrame(() => {
      const b = card.querySelector('[data-kl-pct]');
      if (!b) return;
      const c = Number(v.compare_at_price) || 0, p = Number(v.price) || 0;
      const n = c > p && c > 0 ? Math.round(((c - p) * 100) / c) : 0;
      b.textContent = '-' + n + '%';
      b.hidden = !(n > 0);
    });
  }, true);
})();
